export default {
  baseApiUrl: '/ajax/',
  baseLanguage: 'EN'
}
